import { useRealTimeStore } from '@hotjar/webapp/features/Playbacks/store/realTimeStore';

/**
 * Determine in which direction the timeline jumped to.
 */
export const getJumpDirectionBy = (targetTime: number): 'backward' | 'forward' => {
  return targetTime < useRealTimeStore.getState().currentTime ? 'backward' : 'forward';
};
